const arrayIncludes = (arr, item) => Array.isArray(arr) && arr.findIndex(it => it === item) >= 0;
const isSameArray = (a1, a2) => {
  if (a1 || a2) {
    return Array.isArray(a1) && Array.isArray(a2) && JSON.stringify(a1) === JSON.stringify(a2);
  } else {
    return true;
  }
};
export { arrayIncludes as a, isSameArray as i };